import { useTranslation } from "@/hooks/useTranslation";

export function SkipNavigation() {
  const t = useTranslation();
  return (
    <a
      href="#main-content"
      className="sr-only focus:not-sr-only focus:absolute focus:top-[calc(var(--sa-top)+1rem)] focus:left-4 focus:z-skip focus:px-4 focus:py-2 focus:bg-primary focus:text-primary-foreground focus:rounded-md focus:shadow-lg focus:outline-hidden focus:ring-2 focus:ring-ring focus:ring-offset-2"
      data-testid="link-skip-navigation"
    >
      {t("shellChromeSkipToMain", "Skip to Main Content")}
    </a>
  );
}
